import type { IEntryExitDetailsModel } from '@monorepo/types/document/entryExitDetails/entryExitDetails.types';
import { getToday } from '@monorepo/utils';
import moment from 'moment';

const initState = {
  isInit: true,
  tableList: [],
  total: 0,
  summary: {},
  query: {
    location_id_list: [],
    offset: 0,
    limit: 50,
    storehouse_num_list: [],
    date: getToday(),
    time: [moment('00:00', 'HH:mm'), moment('23:59', 'HH:mm')],
    variant_id_list: [],
  },
};

const goodsInventoryModel: IEntryExitDetailsModel = {
  namespace: 'entryExitDetails',
  state: initState,
  reducers: {
    save(state, action) {
      return {
        ...state,
        ...action.payload,
      };
    },
  },
};

export default goodsInventoryModel;
